// extracted by mini-css-extract-plugin
export var actions = "_md-g";
export var benefitCard = "_md-b";
export var benefitIcon = "_md-d";
export var benefitLabel = "_md-f";
export var benefits = "_md-a";
export var benefitsSection = "_md-8";
export var bodyText = "_md-7";
export var closeButton = "_md-2";
export var content = "_md-3";
export var eyebrow = "_md-4";
export var heading = "_md-5";
export var image = "_md-i";
export var imagePanel = "_md-h";
export var modal = "_md-0";
export var offerCard = "_md-c";
export var offerIcon = "_md-e";
export var sectionLabel = "_md-9";
export var shell = "_md-1";
export var title = "_md-6";